import { Injectable, Injector, runInInjectionContext } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, firstValueFrom, isObservable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardQueue {
  constructor(private injector: Injector) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const guards = route.data['guards'] || [];
    
    for (const guard of guards) {
      let result: any;

      if (typeof guard === 'function' && !guard.prototype?.canActivate) {
        result = runInInjectionContext(this.injector, () => guard(route, state));
      } else {
        try {
          const instance = this.injector.get(guard, null) as any;
          if (!instance) {
            throw new Error(`Provider not found`);
          }
          result = instance.canActivate(route, state);
        } catch (e) {
          console.error(`GuardQueue: provider not found for ${guard.name}.`, e);
          return false;
        }
      }

      if (isObservable(result)) {
        result = await firstValueFrom(result);
      } else {
        result = await result;
      }

      if (result === false || result instanceof UrlTree) {
        return result;
      }
    }

    return true;
  }
}